import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Col, Row, Button } from 'react-materialize';
import { FormattedMessage } from 'react-intl';

class GetStarted extends Component {

	handleClick = () => {
		
	}

	render() {
		return (
			<section className='request-demo-container'>
				<Row>
					<Col s={12}>
						<div className='join-leading-container '>
							<h2 className='get-started-title noselect'>
								<FormattedMessage
									id="get_started.title"
									defaultMessage={"Let's Make Your Voice Heard!"}
								/>
							</h2>
						</div>
					</Col>
					<Col s={12}>
						<div className='tos-container '>
							<p className='tos-text noselect'>
								<FormattedMessage
									id="get_started.body"
									defaultMessage={"Click below to join and start giving feedback on exclusive videos"}
								/>
							</p>
						</div>
					</Col>
					<Col s={12}>
						<div className='req-demo-btn-container '>
							<div>
								<Link to='/register'>
									<Button large waves='light'>
										<FormattedMessage
											id="get_started.button.start"
											defaultMessage={"Get Started"}
										/>
									</Button>
								</Link>
							</div>
						</div>
					</Col>
				</Row>

				{/* <div className='join-leading-container '>
					<h2 className='section-description white-color noselect'>Let's Make Your Voice Heard!</h2>
				</div>

				<div className='tos-container '>
					<p className='tos-text noselect' style={{ color: '#5d7282' }} >Click below to start getting access to exclusive video<Link to='/terms-and-conditions' className='noselect tos-link'>Terms of Services</Link></p>
				</div>

				<div className='req-demo-btn-container '>
					<div>
						<Button large waves='light'>Get Started</Button>
					</div>
				</div> */}
			</section>
		);
	}
}

export default GetStarted;


// WEBPACK FOOTER //
// ./src/components/landing/GetStarted.js